import React from "react"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { FooterNav } from "components/molecules/nav"
import { SearchDetail } from "components/utils/search"
import { APIResponse } from "redux/apis/types"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"

export type Route = {
  name: string
  path: string
  icon: string | React.ReactElement
}

type NavProps = RouteComponentProps & {
  route: Array<Route>
  isSpWindowSize: boolean
}

const executeSearchAction = (data: APIResponse.Res) =>
  store.dispatch(showSymbol(data))

const MainMenu: React.FC<NavProps> = props => {
  return (
    <footer className="footer-nav">
      {!props.isSpWindowSize ? (
        <>
          <FooterNav route={props.route} path={props.location.pathname} />
          {/*<SearchDetail*/}
          {/*  className="search-bar"*/}
          {/*  placeholder="銘柄コード/銘柄名"*/}
          {/*  executeFunction={(obj: APIResponse.Res) => executeSearchAction(obj)}*/}
          {/*  forceActive={true}*/}
          {/*  isDirect={true}*/}
          {/*/>*/}
        </>
      ) : null}
    </footer>
  )
}

export default withRouter(MainMenu)
